"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HANDLEBAR_REGEX = exports.FieldReferenceInputStyle = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _recompose = require("recompose");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _TokenPickerInput = _interopRequireWildcard(require("../TokenPickerInput/TokenPickerInput"));
var _FieldReferenceListItem = _interopRequireDefault(require("./FieldReferenceListItem"));
var _field = require("@catalytic/catalytic-icons/lib/icons/field.svg");
var _excluded = ["classes", "data", "defaultValue", "displayOnly", "hasValidation", "inputClassName", "setDisplayErrorsState", "setLoadingState", "theme", "value", "viewerRead"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var DISPLAY_NAME = 'FieldReferenceInput';

// Matches a handlebar reference when typing '{{'
var HANDLEBAR_REGEX_TRIGGER = /(?:^|[^a-zA-Z0-9])(\{\{([^\s{{]*))$/;
var HANDLEBAR_REGEX = exports.HANDLEBAR_REGEX = /{{([a-zA-Z0-9-_.]+)}}/;
var FieldReferenceInputStyle = exports.FieldReferenceInputStyle = function FieldReferenceInputStyle(theme /*: ThemeType*/) {
  return {
    content: {
      maxWidth: _TokenPickerInput.MAX_WIDTH
    },
    fieldIcon: {
      color: theme.colors.battleshipGrey
    }
  };
};
/*:: export type FieldSuggestion = {
  id: string,
  source?: string,
  display: string,
  type: React.Node
};*/
/*:: type FieldReferenceInputType = InjectSheetProvidedProps &
  HTMLTextAreaElement & {
    data: Array<FieldSuggestion>,
    defaultValue?: string,
    displayOnly?: boolean,
    hasValidation?: boolean,
    inputClassName?: string,
    setDisplayErrorsState?: Function,
    setLoadingState?: Function,
    value?: string,
    viewerRead?: boolean
  };*/
var FieldReferenceInput = /*#__PURE__*/function (_React$PureComponent) {
  function FieldReferenceInput() {
    (0, _classCallCheck2.default)(this, FieldReferenceInput);
    return _callSuper(this, FieldReferenceInput, arguments);
  }
  (0, _inherits2.default)(FieldReferenceInput, _React$PureComponent);
  return (0, _createClass2.default)(FieldReferenceInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        data = _this$props.data,
        defaultValue = _this$props.defaultValue,
        displayOnly = _this$props.displayOnly,
        hasValidation = _this$props.hasValidation,
        inputClassName = _this$props.inputClassName,
        setDisplayErrorsState = _this$props.setDisplayErrorsState,
        setLoadingState = _this$props.setLoadingState,
        theme = _this$props.theme,
        value = _this$props.value,
        viewerRead = _this$props.viewerRead,
        props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(_TokenPickerInput.default, (0, _extends2.default)({
        data: data,
        defaultValue: defaultValue || value || '',
        triggerElement: (data || []).length ? /*#__PURE__*/React.createElement(_field.ReactComponent, {
          className: classes.fieldIcon
        }) : null,
        displayTransform: function displayTransform(id, display) {
          var suggestion = (data || []).find(function (s) {
            return s.id === id;
          });
          if (suggestion) {
            return suggestion.display;
          }
          return "{{".concat(display, "}}");
        },
        markup: "{{__id__}}",
        mentionInputClassName: inputClassName,
        regex: HANDLEBAR_REGEX,
        renderSuggestion: function renderSuggestion(suggestion /*: FieldSuggestion*/) {
          return /*#__PURE__*/React.createElement(_FieldReferenceListItem.default, (0, _extends2.default)({}, suggestion, {
            contentClassName: classes.content
          }));
        },
        trigger: HANDLEBAR_REGEX_TRIGGER
      }, props));
    }
  }]);
}(React.PureComponent);
(0, _defineProperty2.default)(FieldReferenceInput, "displayName", DISPLAY_NAME);
/*:: type EnhancedProps = {
  data: Array<FieldSuggestion>,
  defaultValue?: ?string,
  displayOnly?: boolean,
  inputClassName?: string,
  setDisplayErrorsState?: Function,
  setLoadingState?: Function,
  value?: ?string,
  viewerRead?: boolean
};*/
var EnhancedFieldReferenceInput /*: React.ComponentType<EnhancedProps>*/ = (0, _recompose.compose)((0, _recompose.setDisplayName)(DISPLAY_NAME), (0, _injectSheet.default)(FieldReferenceInputStyle))(FieldReferenceInput);
var _default = exports.default = EnhancedFieldReferenceInput;
//# sourceMappingURL=FieldReferenceInput.js.map